import { Howl, Howler } from 'howler'
import Manifest from './manifest'
import when from "when"

class SoundController {
    constructor() {
        this.sounds = {}
        this.muted = false
        Howler.volume(0.5)
    }

    getLoadables() {
        let promises = []
        for (const key in Manifest.audio) {
            if (Manifest.audio.hasOwnProperty(key)) {
                let promise = when.defer()
                let audio = new Howl({
                    src: [Manifest.audio[key]],
                    html5: false
                })
                promises.push(promise)
                this.sounds[key] = {
                    audio: audio,
                    defer: promise,
                    loop: false,
                    looping: false,
                    playing: false,
                    playTime: null
                }
                audio.once('load', function () {
                    promise.resolve(audio)
                })
            }
        }
        when.all(promises).then(() => {
            this.onLoaded()
        })
        return promises
    }

    onLoaded() {
        
    }

    play(id) {
        if (this.sounds[id] && this.sounds[id].audio) {
            this.sounds[id].audio.seek(0)
            this.sounds[id].audio.play()
        }
    }

    stop(id) {
        if (this.sounds[id] && this.sounds[id].audio) {
            this.sounds[id].audio.stop()
            this.sounds[id].playTime = null
        }
    }

    toggleMute() {
        if (!this.muted) {
            Howler.volume(0)
        } else {
            Howler.volume(0.5)
        }
        this.muted = !this.muted
    }

    setVolume(id, vol) {
        if (this.sounds[id] && this.sounds[id].audio) {
            this.sounds[id].audio.volume(vol)
        }
    }

    fadeIn(id) {
        if (this.sounds[id] && this.sounds[id].audio) {
            this.sounds[id].audio.seek(0)
            this.sounds[id].audio.play()
            this.sounds[id].audio.fade(0, 0.5, 1000)
            this.sounds[id].playing = true
            this.sounds[id].playTime = Date.now()
        }
    }

    fadeOut(id) {
        if (this.sounds[id] && this.sounds[id].audio) {
            this.sounds[id].audio.fade(0.5, 0, 2000)
            this.sounds[id].playing = false
            setTimeout(() => {
                this.sounds[id].audio.stop()
                this.sounds[id].playTime = null
            }, 1500);
        }
    }

    playAndLoop(id) {
        if (this.sounds[id] && this.sounds[id].audio && !this.sounds[id].looping) {
            this.sounds[id].audio.loop(true)
            this.sounds[id].audio.play()
            this.sounds.looping = true
            this.sounds.playing = true
        }
    }
}

const out = new SoundController()
export default out